import { render, staticRenderFns } from "./PdfsPurchases.vue?vue&type=template&id=2f0eca04&scoped=true"
import script from "./PdfsPurchases.vue?vue&type=script&lang=js"
export * from "./PdfsPurchases.vue?vue&type=script&lang=js"
import style0 from "./PdfsPurchases.vue?vue&type=style&index=0&id=2f0eca04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0eca04",
  null
  
)

export default component.exports